import { useEffect } from "react";
import { Briefcase, Mail, DollarSign } from "lucide-react";
import { Link } from "react-router-dom";
import "./Careers.css";

const positions = [
  {
    title: "Finance Intern",
    description:
      "Join our finance team to gain hands-on experience in financial planning, analysis, and reporting for a growing tech company.",
    responsibilities: [
      "Assist with financial forecasting and budgeting",
      "Help prepare financial reports and analyses",
      "Support accounts payable and receivable processes",
      "Contribute to financial strategy development",
    ],
    formLink: "https://forms.gle/KWWSzaPZoS62zYTR9",
  },
  {
    title: "Grants, Data & Conference Intern",
    description:
      "Help us secure funding opportunities and manage our presence at industry conferences and events.",
    responsibilities: [
      "Research grant opportunities and assist with applications",
      "Collect and analyze data for reporting purposes",
      "Help organize and coordinate conference participation",
      "Assist with presentation materials preparation",
    ],
    formLink: "https://forms.gle/WJ4yumGR235Lw6VQ6",
  },
  {
    title: "Market Research & Strategy Intern",
    description:
      "Contribute to our market research efforts and help shape our go-to-market strategies.",
    responsibilities: [
      "Conduct competitor analysis and market research",
      "Assist with customer surveys and feedback collection",
      "Help analyze market trends and opportunities",
      "Support the development of marketing materials",
    ],
    formLink: "https://forms.gle/y6JmhRpStEEG4DgXA",
  },
  {
    title: "Supply Chain & Logistics Intern",
    description:
      "Learn about supply chain management and logistics in the hardware technology sector.",
    responsibilities: [
      "Assist with inventory management and tracking",
      "Help coordinate with suppliers and manufacturers",
      "Support shipping and fulfillment operations",
      "Contribute to supply chain optimization efforts",
    ],
    formLink: "https://forms.gle/18jGEhy8id8mVkTG8",
  },
  {
    title: "Software Engineering & Cyber Security Intern",
    description:
      "Work alongside our tech team to develop and secure our software applications.",
    responsibilities: [
      "Assist with software development and testing",
      "Help identify and address security vulnerabilities",
      "Contribute to code reviews and documentation",
      "Support the implementation of security best practices",
    ],
    formLink: "https://forms.gle/Tk8Anvrxy42JVYb36",
  },
];

export default function Careers() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="careers-page">
      <div className="careers-header">
        <h1>Join Our Team</h1>
        <p>
          At ChipServer, we're building the future of portable cloud technology. Join our innovative team and help shape the next generation of data storage and broadcasting solutions.
        </p>
      </div>

      {/* Referral Program Section */}
      <div className="career-card referral-program">
        <div className="career-card-header">
          <DollarSign className="icon" />
          <h3>Promote ChipServer, Make Money!</h3>
        </div>
        <p className="description">
          Join our referral program and earn competitive commissions for every successful referral. Help businesses discover the power of portable cloud technology while building your own income stream.
        </p>

        <div className="responsibilities">
          <strong>Program Benefits:</strong>
          <ul>
            <li>Competitive commission rates (15% of sale)</li>
           
            <li>Marketing materials provided</li>
            <li>Dedicated support team</li>
          </ul>
        </div>

        <div className="career-card-footer">
          <Link
            to="/contact"
            className="btn-outline"
          >
            Learn More
          </Link>
          <a
            href="https://forms.gle/irELVm13s3BZbDRX9"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary"
          >
            Join Program
          </a>
        </div>
      </div>

      <div className="careers-list">
        {positions.map((position, index) => (
          <div key={index} className="career-card">
            <div className="career-card-header">
              <Briefcase className="icon" />
              <h3>{position.title}</h3>
            </div>
            <p className="description">{position.description}</p>

            <div className="responsibilities">
              <strong>Key Responsibilities:</strong>
              <ul>
                {position.responsibilities.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            </div>

            <div className="career-card-footer">
              <Link
                to={`/contact?message=${encodeURIComponent(
                  `I'd like to learn more about the ${position.title} position!`
                )}`}
                className="btn-outline"
              >
                Learn More
              </Link>
              <a
                href={position.formLink}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary"
              >
                Apply Now
              </a>
            </div>
          </div>
        ))}
      </div>

      <div className="careers-cta">
        <h2>Don't see the right fit?</h2>
        <p>
          We're always looking for talented individuals to join our team. Send us your resume and let us know how you can contribute to ChipServer.
        </p>
        <Link to="/contact" className="btn-primary">
          <Mail className="icon" /> Contact Us
        </Link>
      </div>
    </div>
  );
}
